import BaseRoute from "utils/base_route";

import LlmRunList from "./containers/llm_run_list";
import llmRunsClearAction from "modules/flowmaster/actions/llm_runs_clear";

export default class LlmRunListRoute extends BaseRoute {
  constructor(store) {
    super("list", store);
  }

  getChildRoutes(state, cb) {
    cb(null, []);
  }
  getComponents(location, cb) {
    cb(null, LlmRunList);
  }

  clearActiveData() {
    const {dispatch} = this.store;
    dispatch(llmRunsClearAction());
  }
}
